module.exports = __webpack_public_path__ + "./images/3bde775eaa61ce58c28925ed5b85c220.webp";